import pxToRem from "assets/theme/functions/pxToRem";

const icon = {
  defaultProps: {
    baseClassName: "material-icons-round",
    fontSize: "inherit",
  },

  styleOverrides: {
    root: {
      color: "#64748b", // 🔥 subtle gray (not bright)
    },

    fontSizeInherit: {
      fontSize: "inherit !important",
    },

    fontSizeSmall: {
      fontSize: `${pxToRem(18)} !important`, // 🔥 smaller
    },

    fontSizeLarge: {
      fontSize: `${pxToRem(28)} !important`, // 🔥 reduce
    },
  },
};

export default icon;